/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

// jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

/*!
	Colorbox 1.6.1
	license: MIT
	http://www.jacklmoore.com/colorbox
    CT: Added  minWidth/minHeight
*/
!function(t,e,i){function n(i,n,o){var h=e.createElement(i);return n&&(h.id=Z+n),o&&(h.style.cssText=o),t(h)}function o(){return i.innerHeight?i.innerHeight:t(i).height()}function h(e,i){i!==Object(i)&&(i={}),this.cache={},this.el=e,this.value=function(e){var n;return void 0===this.cache[e]&&(n=t(this.el).attr("data-cbox-"+e),void 0!==n?this.cache[e]=n:void 0!==i[e]?this.cache[e]=i[e]:void 0!==X[e]&&(this.cache[e]=X[e])),this.cache[e]},this.get=function(e){var i=this.value(e);return t.isFunction(i)?i.call(this.el,this):i}}function r(t){var e=k.length,i=(A+t)%e;return 0>i?e+i:i}function a(t,e){return Math.round((/%/.test(t)?("x"===e?E.width():o())/100:1)*parseInt(t,10))}function s(t,e){return t.get("photo")||t.get("photoRegex").test(e)}function l(t,e){return t.get("retinaUrl")&&i.devicePixelRatio>1?e.replace(t.get("photoRegex"),t.get("retinaSuffix")):e}function d(t){"contains"in y[0]&&!y[0].contains(t.target)&&t.target!==v[0]&&(t.stopPropagation(),y.focus())}function c(t){c.str!==t&&(y.add(v).removeClass(c.str).addClass(t),c.str=t)}function g(e){A=0,e&&e!==!1&&"nofollow"!==e?(k=t("."+te).filter(function(){var i=t.data(this,Y),n=new h(this,i);return n.get("rel")===e}),A=k.index(_.el),-1===A&&(k=k.add(_.el),A=k.length-1)):k=t(_.el)}function u(i){t(e).trigger(i),ae.triggerHandler(i)}function f(i){var o;if(!G){if(o=t(i).data(Y),_=new h(i,o),g(_.get("rel")),!$){$=q=!0,c(_.get("className")),y.css({visibility:"hidden",display:"block",opacity:""}),I=n(se,"LoadedContent","width:0; height:0; overflow:hidden; visibility:hidden"),b.css({width:"",height:""}).append(I),j=T.height()+W.height()+b.outerHeight(!0)-b.height(),D=C.width()+H.width()+b.outerWidth(!0)-b.width(),N=I.outerHeight(!0),z=I.outerWidth(!0);var r=a(_.get("initialWidth"),"x"),s=a(_.get("initialHeight"),"y"),l=_.get("maxWidth"),f=_.get("maxHeight");_.w=(l!==!1?Math.min(r,a(l,"x")):r)-z-D,_.h=(f!==!1?Math.min(s,a(f,"y")):s)-N-j,I.css({width:"",height:_.h}),J.position(),u(ee),_.get("onOpen"),O.add(S).hide(),y.focus(),_.get("trapFocus")&&e.addEventListener&&(e.addEventListener("focus",d,!0),ae.one(he,function(){e.removeEventListener("focus",d,!0)})),_.get("returnFocus")&&ae.one(he,function(){t(_.el).focus()})}var p=parseFloat(_.get("opacity"));v.css({opacity:p===p?p:"",cursor:_.get("overlayClose")?"pointer":"",visibility:"visible"}).show(),_.get("closeButton")?B.html(_.get("close")).appendTo(b):B.appendTo("<div/>"),w()}}function p(){y||(V=!1,E=t(i),y=n(se).attr({id:Y,"class":t.support.opacity===!1?Z+"IE":"",role:"dialog",tabindex:"-1"}).hide(),v=n(se,"Overlay").hide(),M=t([n(se,"LoadingOverlay")[0],n(se,"LoadingGraphic")[0]]),x=n(se,"Wrapper"),b=n(se,"Content").append(S=n(se,"Title"),F=n(se,"Current"),P=t('<button type="button"/>').attr({id:Z+"Previous"}),K=t('<button type="button"/>').attr({id:Z+"Next"}),R=n("button","Slideshow"),M),B=t('<button type="button"/>').attr({id:Z+"Close"}),x.append(n(se).append(n(se,"TopLeft"),T=n(se,"TopCenter"),n(se,"TopRight")),n(se,!1,"clear:left").append(C=n(se,"MiddleLeft"),b,H=n(se,"MiddleRight")),n(se,!1,"clear:left").append(n(se,"BottomLeft"),W=n(se,"BottomCenter"),n(se,"BottomRight"))).find("div div").css({"float":"left"}),L=n(se,!1,"position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;"),O=K.add(P).add(F).add(R)),e.body&&!y.parent().length&&t(e.body).append(v,y.append(x,L))}function m(){function i(t){t.which>1||t.shiftKey||t.altKey||t.metaKey||t.ctrlKey||(t.preventDefault(),f(this))}return y?(V||(V=!0,K.click(function(){J.next()}),P.click(function(){J.prev()}),B.click(function(){J.close()}),v.click(function(){_.get("overlayClose")&&J.close()}),t(e).bind("keydown."+Z,function(t){var e=t.keyCode;$&&_.get("escKey")&&27===e&&(t.preventDefault(),J.close()),$&&_.get("arrowKey")&&k[1]&&!t.altKey&&(37===e?(t.preventDefault(),P.click()):39===e&&(t.preventDefault(),K.click()))}),t.isFunction(t.fn.on)?t(e).on("click."+Z,"."+te,i):t("."+te).live("click."+Z,i)),!0):!1}function w(){var e,o,h,r=J.prep,d=++le;if(q=!0,U=!1,u(re),u(ie),_.get("onLoad"),_.h=_.get("height")?a(_.get("height"),"y")-N-j:_.get("innerHeight")&&a(_.get("innerHeight"),"y"),_.w=_.get("width")?a(_.get("width"),"x")-z-D:_.get("innerWidth")&&a(_.get("innerWidth"),"x"),_.mw=_.w,_.mh=_.h,_.get("maxWidth")&&(_.mw=a(_.get("maxWidth"),"x")-z-D,_.mw=_.w&&_.w<_.mw?_.w:_.mw),_.get("maxHeight")&&(_.mh=a(_.get("maxHeight"),"y")-N-j,_.mh=_.h&&_.h<_.mh?_.h:_.mh),e=_.get("href"),Q=setTimeout(function(){M.show()},100),_.get("inline")){var c=t(e);h=t("<div>").hide().insertBefore(c),ae.one(re,function(){h.replaceWith(c)}),r(c)}else _.get("iframe")?r(" "):_.get("html")?r(_.get("html")):s(_,e)?(e=l(_,e),U=_.get("createImg"),t(U).addClass(Z+"Photo").bind("error."+Z,function(){r(n(se,"Error").html(_.get("imgError")))}).one("load",function(){d===le&&setTimeout(function(){var e;_.get("retinaImage")&&i.devicePixelRatio>1&&(U.height=U.height/i.devicePixelRatio,U.width=U.width/i.devicePixelRatio),_.get("scalePhotos")&&(o=function(){U.height-=U.height*e,U.width-=U.width*e},_.mw&&U.width>_.mw&&(e=(U.width-_.mw)/U.width,o()),_.mh&&U.height>_.mh&&(e=(U.height-_.mh)/U.height,o())),(_.h||_.get("minHeight"))&&(U.style.marginTop=Math.max((_.h||_.get("minHeight"))-U.height,0)/2+"px"),k[1]&&(_.get("loop")||k[A+1])&&(U.style.cursor="pointer",t(U).bind("click."+Z,function(){J.next()})),U.style.width=U.width+"px",U.style.height=U.height+"px",r(U)},1)}),U.src=e):e&&L.load(e,_.get("data"),function(e,i){d===le&&r("error"===i?n(se,"Error").html(_.get("xhrError")):t(this).contents())})}var v,y,x,b,T,C,H,W,k,E,I,L,M,S,F,R,K,P,B,O,_,j,D,N,z,A,U,$,q,G,Q,J,V,X={html:!1,photo:!1,iframe:!1,inline:!1,transition:"elastic",speed:300,fadeOut:300,width:!1,initialWidth:"600",innerWidth:!1,maxWidth:!1,minWidth:!1,height:!1,initialHeight:"450",innerHeight:!1,maxHeight:!1,minHeight:!1,scalePhotos:!0,scrolling:!0,opacity:.9,preloading:!0,className:!1,overlayClose:!0,escKey:!0,arrowKey:!0,top:!1,bottom:!1,left:!1,right:!1,fixed:!1,data:void 0,closeButton:!0,fastIframe:!0,open:!1,reposition:!0,loop:!0,slideshow:!1,slideshowAuto:!0,slideshowSpeed:2500,slideshowStart:"start slideshow",slideshowStop:"stop slideshow",photoRegex:/\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,retinaImage:!1,retinaUrl:!1,retinaSuffix:"@2x.$1",current:"image {current} of {total}",previous:"previous",next:"next",close:"close",xhrError:"This content failed to load.",imgError:"This image failed to load.",returnFocus:!0,trapFocus:!0,onOpen:!1,onLoad:!1,onComplete:!1,onCleanup:!1,onClosed:!1,rel:function(){return this.rel},href:function(){return t(this).attr("href")},title:function(){return this.title},createImg:function(){var e=new Image,i=t(this).data("cbox-img-attrs");return"object"==typeof i&&t.each(i,function(t,i){e[t]=i}),e},createIframe:function(){var i=e.createElement("iframe"),n=t(this).data("cbox-iframe-attrs");return"object"==typeof n&&t.each(n,function(t,e){i[t]=e}),"frameBorder"in i&&(i.frameBorder=0),"allowTransparency"in i&&(i.allowTransparency="true"),i.name=(new Date).getTime(),i.allowFullScreen=!0,i}},Y="colorbox",Z="cbox",te=Z+"Element",ee=Z+"_open",ie=Z+"_load",ne=Z+"_complete",oe=Z+"_cleanup",he=Z+"_closed",re=Z+"_purge",ae=t("<a/>"),se="div",le=0,de={},ce=function(){function t(){clearTimeout(r)}function e(){(_.get("loop")||k[A+1])&&(t(),r=setTimeout(J.next,_.get("slideshowSpeed")))}function i(){R.html(_.get("slideshowStop")).unbind(s).one(s,n),ae.bind(ne,e).bind(ie,t),y.removeClass(a+"off").addClass(a+"on")}function n(){t(),ae.unbind(ne,e).unbind(ie,t),R.html(_.get("slideshowStart")).unbind(s).one(s,function(){J.next(),i()}),y.removeClass(a+"on").addClass(a+"off")}function o(){h=!1,R.hide(),t(),ae.unbind(ne,e).unbind(ie,t),y.removeClass(a+"off "+a+"on")}var h,r,a=Z+"Slideshow_",s="click."+Z;return function(){h?_.get("slideshow")||(ae.unbind(oe,o),o()):_.get("slideshow")&&k[1]&&(h=!0,ae.one(oe,o),_.get("slideshowAuto")?i():n(),R.show())}}();t[Y]||(t(p),J=t.fn[Y]=t[Y]=function(e,i){var n,o=this;return e=e||{},t.isFunction(o)&&(o=t("<a/>"),e.open=!0),o[0]?(p(),m()&&(i&&(e.onComplete=i),o.each(function(){var i=t.data(this,Y)||{};t.data(this,Y,t.extend(i,e))}).addClass(te),n=new h(o[0],e),n.get("open")&&f(o[0])),o):o},J.position=function(e,i){function n(){T[0].style.width=W[0].style.width=b[0].style.width=parseInt(y[0].style.width,10)-D+"px",b[0].style.height=C[0].style.height=H[0].style.height=parseInt(y[0].style.height,10)-j+"px"}var h,r,s,l=0,d=0,c=y.offset();if(E.unbind("resize."+Z),y.css({top:-9e4,left:-9e4}),r=E.scrollTop(),s=E.scrollLeft(),_.get("fixed")?(c.top-=r,c.left-=s,y.css({position:"fixed"})):(l=r,d=s,y.css({position:"absolute"})),d+=_.get("right")!==!1?Math.max(E.width()-_.w-z-D-a(_.get("right"),"x"),0):_.get("left")!==!1?a(_.get("left"),"x"):Math.round(Math.max(E.width()-_.w-z-D,0)/2),l+=_.get("bottom")!==!1?Math.max(o()-_.h-N-j-a(_.get("bottom"),"y"),0):_.get("top")!==!1?a(_.get("top"),"y"):Math.round(Math.max(o()-_.h-N-j,0)/2),y.css({top:c.top,left:c.left,visibility:"visible"}),x[0].style.width=x[0].style.height="9999px",h={width:_.w+z+D,height:_.h+N+j,top:l,left:d},e){var g=0;t.each(h,function(t){return h[t]!==de[t]?void(g=e):void 0}),e=g}de=h,e||y.css(h),y.dequeue().animate(h,{duration:e||0,complete:function(){n(),q=!1,x[0].style.width=_.w+z+D+"px",x[0].style.height=_.h+N+j+"px",_.get("reposition")&&setTimeout(function(){E.bind("resize."+Z,J.position)},1),t.isFunction(i)&&i()},step:n})},J.resize=function(t){var e;$&&(t=t||{},t.width&&(_.w=a(t.width,"x")-z-D),t.innerWidth&&(_.w=a(t.innerWidth,"x")),I.css({width:_.w}),t.height&&(_.h=a(t.height,"y")-N-j),t.innerHeight&&(_.h=a(t.innerHeight,"y")),t.innerHeight||t.height||(e=I.scrollTop(),I.css({height:"auto"}),_.h=I.height()),I.css({height:_.h}),e&&I.scrollTop(e),J.position("none"===_.get("transition")?0:_.get("speed")))},J.prep=function(i){function o(){return _.w=_.w||I.width(),_.get("minWidth")&&_.w<_.get("minWidth")&&(_.w=a(_.get("minWidth"),"x")),_.w=_.mw&&_.mw<_.w?_.mw:_.w,_.w}function d(){return _.h=_.h||I.height(),_.get("minHeight")&&_.h<_.get("minHeight")&&(_.h=a(_.get("minHeight"),"y")),_.h=_.mh&&_.mh<_.h?_.mh:_.h,_.h}if($){var g,f="none"===_.get("transition")?0:_.get("speed");I.remove(),I=n(se,"LoadedContent").append(i),I.hide().appendTo(L.show()).css({width:o(),overflow:_.get("scrolling")?"auto":"hidden"}).css({height:d()}).prependTo(b),L.hide(),t(U).css({"float":"none"}),c(_.get("className")),g=function(){function i(){t.support.opacity===!1&&y[0].style.removeAttribute("filter")}var n,o,a=k.length;$&&(o=function(){clearTimeout(Q),M.hide(),u(ne),_.get("onComplete")},S.html(_.get("title")).show(),I.show(),a>1?("string"==typeof _.get("current")&&F.html(_.get("current").replace("{current}",A+1).replace("{total}",a)).show(),K[_.get("loop")||a-1>A?"show":"hide"]().html(_.get("next")),P[_.get("loop")||A?"show":"hide"]().html(_.get("previous")),ce(),_.get("preloading")&&t.each([r(-1),r(1)],function(){var i,n=k[this],o=new h(n,t.data(n,Y)),r=o.get("href");r&&s(o,r)&&(r=l(o,r),i=e.createElement("img"),i.src=r)})):O.hide(),_.get("iframe")?(n=_.get("createIframe"),_.get("scrolling")||(n.scrolling="no"),t(n).attr({src:_.get("href"),"class":Z+"Iframe"}).one("load",o).appendTo(I),ae.one(re,function(){n.src="//about:blank"}),_.get("fastIframe")&&t(n).trigger("load")):o(),"fade"===_.get("transition")?y.fadeTo(f,1,i):i())},"fade"===_.get("transition")?y.fadeTo(f,0,function(){J.position(0,g)}):J.position(f,g)}},J.next=function(){!q&&k[1]&&(_.get("loop")||k[A+1])&&(A=r(1),f(k[A]))},J.prev=function(){!q&&k[1]&&(_.get("loop")||A)&&(A=r(-1),f(k[A]))},J.close=function(){$&&!G&&(G=!0,$=!1,u(oe),_.get("onCleanup"),E.unbind("."+Z),v.fadeTo(_.get("fadeOut")||0,0),y.stop().fadeTo(_.get("fadeOut")||0,0,function(){y.hide(),v.hide(),u(re),I.remove(),setTimeout(function(){G=!1,u(he),_.get("onClosed")},1)}))},J.remove=function(){y&&(y.stop(),t[Y].close(),y.stop(!1,!0).remove(),v.remove(),G=!1,y=null,t("."+te).removeData(Y).removeClass(te),t(e).unbind("click."+Z).unbind("keydown."+Z))},J.element=function(){return t(_.el)},J.settings=X)}(jQuery,document,window);
// theme.jQuery = jQuery;

//Top bar slider
$(document).ready(function() {
  //if (theme.template == 'cart') return;

	/*var BREAKPOINT = 1023;
    var sellingPointsSlideIndex = 0;
    var sellingPointsSlider = ".headaer-toop ul";
    var windowWidth = $(window).width();

    var sellingPointsSliderConfig = {
		slidesToShow: 2,
		slidesToScroll: 2,
		arrows: true,
		infinite: true,
		dots: false,
      	variableWidth: false,
		touchMove: true,
		prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fa fa-chevron-left"></i></button>',
		nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fa fa-chevron-right"></i></button>',
      	responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: false
            }
          }
        ]
	};

    if (windowWidth >= BREAKPOINT) {
	
	} else {
		$(sellingPointsSlider).on("afterChange", function (event, slick, currentSlide) {
			sellingPointsSlideIndex = currentSlide;
	    }).slick(sellingPointsSliderConfig);
	}
	var resizeTimeout;
	$(window).resize(function() {		
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function() {
			var windowWidth = $(window).width();
			if (windowWidth >= BREAKPOINT) {
				//desktop
				if ($('.headaer-toop ul.slick-initialized').length > 0) {
					$(sellingPointsSlider).slick("unslick");
				}	
			} else {
				// mobile
				if ($('.headaer-toop ul.slick-initialized').length == 0) {
					//console.log('slick first time');
					$(sellingPointsSlider).slick(sellingPointsSliderConfig);
				} else {
					$(sellingPointsSlider).slick("unslick").slick(sellingPointsSliderConfig);
					$(sellingPointsSlider).slick('slickGoTo', sellingPointsSlideIndex, true);
				}
				
			}
		}, 300);
	});*/

    var announcementinit = {
      autoplay: true,
      infinite: true,
      cssEase: "linear",
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed: 3000,
      arrows: false
      // prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fa fa-chevron-left"></i></button>',
      // nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fa fa-chevron-right"></i></button>',
    };
    $(function () {
      var win = $(window);
      var announcementslider = $(".headaer-toop ul");
    
      win.on("load resize", function () {
        if (win.width() < 576) {
          announcementslider.not(".slick-initialized").slick(announcementinit);
        } else if (announcementslider.hasClass("slick-initialized")) {
          announcementslider.slick("unslick");
        }
      });
    });
  
    var limespotmin = setInterval(checklimespot, 3000);
	function checklimespot(){
		if(jQuery('.limespot-recommendation-box-carousel-shelf').length > 0){
			clearInterval(limespotmin);
			limespotomeadd("ul.limespot-recommendation-box-carousel-shelf .limespot-recommendation-box-item");
		}
      if(jQuery('.limespot-recommendation-box-grid').length > 0){
			clearInterval(limespotmin);
			limespotomeadd("ul.limespot-recommendation-box-grid .limespot-recommendation-box-item");
		}
	}
    function limespotomeadd(lsClassName){      
      $(lsClassName).each(function() {
		
        var $this = jQuery(this);
        var installementText = '';
        var wishlisticon = '';
        var productId = $this.find('.ls-link').attr('data-product-identifier'); 
        var productLink = $this.find('.ls-link').attr('href'); 
        
        var productHandle = productLink.split("?");
        productHandle = productHandle[0].split("products/")[1];
    
        var CP = $this.find('.ls-price').attr('data-numeric-value'); 
        if (CP > 1 && CP < 1501) {
            var emi = ((CP)/4);
            var with2Decimals = emi.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
            installementText += '<span class="installement-limespot">Or 4 payments of $'+ with2Decimals +' with <img src="https://cdn.shopify.com/s/files/1/0057/6657/8279/files/afterpay-logo-png-black-transparent.png?v=1616483054" alt="Afterpay">';
          }
          if (CP > 1500){
            var emi = ((CP)/52);
            var with2Decimals = emi.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
            installementText += '<span class="installement-limespot">or pay $'+with2Decimals +' per week.*';
          }
        wishlisticon = '<span class="wishlistitem ftc"><a data-product='+productId+' data-producthandle='+productHandle+' href="javascript:void(0)"><svg style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g class="st0" id="Layer_1"/><g id="Layer_2"><path class="st2" d="M57.3,32.7c-9.2-9.2-24.1-9.2-33.3,0c-9.2,9.2-9.2,24.1,0,33.3l6.7,6.7L64,106l33.3-33.3L104,66   c9.2-9.2,9.2-24.1,0-33.3s-24.1-9.2-33.3,0L64,39.4"/></g></svg></a></span>';
        $this.append(installementText);
        $this.find('.ls-price-wrap').append(wishlisticon);
        if ($this.parents('.limespot-for-upsell-popup').length) {  
          var newSrc = ($this.find('.ls-image').attr('data-img-raw-src'));
          var VariantId = $this.find('.ls-add-to-cart').attr('data-variant-id'); 
          var orignalPrice = $this.find('.ls-original-price').html(); 
         
          $($this.find('.ls-image').attr('src', newSrc));
          $this.find('.ls-info-wrap').append('<div class="price-box"><input type="checkbox" class="upgrade_product" value="'+VariantId+'"/><div id="price" class="product-price "><span class="current-price theme-money"><small>Only</small> A$'+CP+'</span> <del>'+orignalPrice+'</del></div></div>');
        }
      });
	}
  
    $('input[name="care_plan"]').on('change', function() {
  		$('input[name="care_plan"]').not(this).prop('checked', false);  
	});
    $('body').append($('#mobile-navigation-template').html());
    setTimeout(function() {
      var mobile_nav = $('.main-nav > ul.main-nav-list').clone().addClass('mobile-nav-menu plain');
      $(mobile_nav).insertBefore('#mobile-nav .sub-mobile-nav');
      $('#mobile-nav .side-nav-wrapper').addClass('sub-nav-list plain');
      $('#mobile-nav .mobile-nav-menu .nav-item-link + svg').wrap('<button class="open-sub-nav">Mobile navigation arrow</button>');
      $('#mobile-nav .mobile-nav-menu .sub-nav-list .side-nav .ismenuonjewellery_true a svg').wrap('<button class="open-sub-side-nav"></button>');
      
      $('<div class="right-menu-clone"></div>').insertAfter('#mobile-nav .side-nav .col-left .shop-by-type:last-child');
      
      $('#mobile-nav .side-nav li .side-sub-nav').each(function(){    
      	var right_menu = $(this).find('.col-right');
        $(right_menu).appendTo($(this).find('.right-menu-clone'));
      });
    }, 500);
  
  /*$(document).on('click', '#mobile-nav .side-nav .open-sub-nav', function(e){
    e.preventDefault();
    $(this).toggleClass('opened');
    $(this).parent('a').siblings('.side-sub-nav').addClass('slideSubMenuIn');
  });*/
  
  $('#mobile-nav .side-nav .open-sub-nav').parent('a').click(function(e){
  	e.preventDefault();
    $(this).find('.open-sub-nav').toggleClass('opened');
    $(this).siblings('.side-sub-nav').addClass('slideSubMenuIn');
  });
  
  $(document).on('click', '#mobile-nav .side-sub-nav .back-btn', function(e){
    //e.preventDefault();
    //$(this).parent('a').siblings('.side-sub-nav').slideToggle();
    $('.side-sub-nav').removeClass('slideSubMenuIn');
  });

  if((navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPhod/i)) || (navigator.userAgent.match(/iPad/i))) {
    $('.main-nav .nav-item.dropdown a').each(function() {
      var onClick;
      var firstClick = function(){
        onClick = secondClick;
        return false;
      }
      var secondClick = function(){
        onClick = firstClick;
        return true;
      }
      onClick = firstClick;
      $(this).click(function(){
        return onClick();
      });
    });
  }
  /// Mobile sub-nav
  var navStack = [];
  $(document).on('click', '#mobile-nav .open-sub-nav', function(e){
    e.preventDefault();
    $(this).toggleClass('opened');
    $(this).parent('.nav-item').find('.sub-nav-list').slideToggle();
  })
  $(document).on('click', '#mobile-nav .open-sub-side-nav', function(e){
    e.preventDefault();
    $(this).toggleClass('opened');
    $(this).parent('a').toggleClass('active');
    //$(this).siblings('.sub-nav-list').slideToggle();
    $(this).parent('a').siblings('.side-sub-nav').slideToggle();
  });

  /// Dropdowns that redirect
  $(document).on('change', 'select.redirect', function(){
    window.location = $(this).val();
  });

   $('.main-nav ul li.nav-item .mainsubmenus').each(function(){
    $(this).prev('a').click(function(event){
      	event.preventDefault();
      	if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this).siblings(".mainsubmenus").slideUp();
          $('.menu-overlay').hide();
        } else {          
          $("li.nav-item > a").removeClass("active");
          $(this).addClass("active");
          $(".mainsubmenus").fadeOut('slow');
          $(this).siblings(".mainsubmenus").slideDown();
          $('.menu-overlay').show();
        }
    });
  });
  
  $('.mainsubmenus .close-button').click(function(){
    $("li.nav-item > a").removeClass("active");
  	$(".mainsubmenus").slideUp();
    $('.menu-overlay').hide();
  });
  
  $('.menu-overlay').click(function(){
    $("li.nav-item > a").removeClass("active");
  	$(".mainsubmenus").slideUp();
    $('.menu-overlay').hide();
  });
  // Ensuring sub nav dropdown does not go off the RHS of page
  $(window).on('debouncedresize load ensuredropdownposition', function(){
    setTimeout(function(){
      var pw = $('.main-nav').width() + $('.main-nav').offset().left;
      $('.main-nav .nav-item.drop-norm .sub-nav').css('transform', '').each(function(){
        $(this).css({ visibility: 'hidden', zIndex: -1 }).css({ display: 'flex' });
        var oobr = pw - ($(this).offset().left + $(this).outerWidth());
        var oobl = $(this).offset().left;
        if(oobr < 0) {
          // off the right
          $(this).css('transform', 'translate('+Math.ceil(oobr-1)+'px)');
        } else if(oobl < 0) {
          // off the left
          $(this).css('transform', 'translate('+Math.ceil(-oobl)+'px)');
        }
        $(this).css({ visibility: '', zIndex: '', display: '' });
      });
    }, 50);
  });
  $('body').on('change','.rang-fields', function(e){
    var idSelected3yr	= $('option:selected', this).attr('rel');
    var idSelected10yr	= $('option:selected', this).attr('rel1');
    
    $(this).parents('.selected-plan-data').find('.plan-price.3-yr').text(idSelected3yr);
    $(this).parents('.selected-plan-data').find('.plan-price.10-yr').text(idSelected10yr);
  });
  
  jQuery('body').on('click', '.upsellproductformbutton', function (e) {
  var $this = jQuery(this).parents('.upsellproductform');
  var variant_id = $this.find('.productvariant').val();
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {id: variant_id,quantity: 1, form_type: "product"},
      dataType: 'json',
      success: function() { 
        location.reload(); 
      }
    });
});
  $('body').on('click','.footerpaymentmethod, .paymentmethodlist .fancybox-button, .paymentpopupopen',function(){
    if($('.paymentmethodlist').attr('rel') == 'show'){
      $('.paymentmethodlist').attr('rel', 'hide').hide();
      $('body .paymentpopupopen').remove();
    }else{
      $('.paymentmethodlist').attr('rel', 'show').html($('#footerpayment_methods').html()).show();
      $('.paymentmethodlist').prepend('<button type="button" class="fancybox-button fancybox-close-small" title="Close"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg></button>');
      $('body').prepend('<div class="paymentpopupopen"></div>');
    }
  });
});

$(function () {
    $('.main-nav ul li.nav-item.dropdown').hover(function(){
  	$(this).addClass('isHovered');
    $('.menu-overlay').show();
    $(".mainsubmenus").fadeOut('slow');
    $("li.nav-item > a").removeClass("active");
    
    $(this).find('.shopify-section > li').hover(function(){
  		$('.main-nav ul li.nav-item.dropdown').removeClass('isHovered'); 
    })
  },function(){
    $('.main-nav ul li.nav-item.dropdown').removeClass('isHovered');
    $('.menu-overlay').hide();
  });
  $(".acc-content").css("display", "none");
  // $(".js-accordion-title").addClass("open");
 
  $(".js-accordion-title").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
  //$('body').append($('#mobile-navigation-template').html());
  
});
// Mobile Menu
 $(document).on('click', '.toggle-mob-nav', function(){
    //prep for reveal
    $('#cart-summary').removeClass('active');
    $('#mobile-nav').addClass('active');
    $('#mobile-nav .side-sub-nav').removeClass('slideSubMenuIn');
    $('#mobile-nav .sub-nav-list').slideUp();
    //toggle
    if(!$('body').toggleClass('show-mobile-nav').hasClass('show-mobile-nav')) {
      //sideModTransOutHelper();
      //$('#mobile-nav').slideDown();
      setTimeout(function(){
        $('#mobile-nav').removeAttr('tabindex');
        $('body a:first:visible').focus();
      }, 500);
    } else {
      // move focus to menu container
      setTimeout(function(){
        $('#mobile-nav').attr('tabindex', '0').focus();
      }, 500);
    }
    //fixedNavWebkitHack();
    return false;
  });
// 

var shopifyAjaxAddURL = '/cart/add.js';
var shopifyAjaxCartURL = '/cart.js';
var shopifyAjaxStorePageURL = '/search';
$.createCookie = function(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
};
$.readCookie = function(name) {
    var nameEQ = name + "=";
    try {
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
    } catch(error) {}
    return null;
};
$.eraseCookie = function(name) {
    $.createCookie(name,"",-1);
};

$(document).ready(function()  {
  if($('.disney-banner-slider').length > 0){
    $('.disney-banner-slider').slick({
      slidesToShow: 1,
      infinite: false,
      slidesToScroll: 1,
      arrows: false,
      //autoplay: true,
      fade: true,
      asNavFor: '.thumbnail-slider1'
    });
  }
  if($('.thumbnail-slider1').length > 0){
    $('.thumbnail-slider1').slick({
      //infinite: false,
      slidesToShow: 11,
      slidesToScroll: 1,
      asNavFor: '.disney-banner-slider',
      dots: false,
      arrows: false,            
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            slidesToShow: 5.2
          }
        },
        {
          breakpoint: 640,
          settings: {
            arrows: false,
            slidesToShow: 3.2
          }
        }
      ]
    });
  }

  if($('.testimonial-slider').length > 0){             
    $('.testimonial-slider').slick({
      dots: true,
      prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fa fa-chevron-right"></i></button>'
    });
  }
  function upsellSlider_pdp(){
	$('.added-notice .upsell-section-slider1').slick({
      slidesToShow: 1,
      //infinite: false,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fa fa-chevron-right"></i></button>'
      //autoplay: true,
      //fade: true
    });
    if($('input[name="care_plan"]:checked').val()){
      $('.added-notice .upsell-section-slider1').slick('slickRemove', 0);
    }
  }
  
  theme.icons = {
  left: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
  right: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
  close: '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/><path d="M0 0h24v24H0z" fill="none"/></svg>',
  chevronLeft: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg>',
  chevronRight: '<svg fill="#000000" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg>',
  tick: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>'
};
 theme.productData = {};
  window.showQuickPopup = function(message, $origin){
    var $popup = $('<div class="simple-popup"/>');
    var offs = $origin.offset();
    $popup.html(message).css({ 'left':offs.left, 'top':offs.top }).hide();
    $('body').append($popup);
    $popup.css({ marginTop: - $popup.outerHeight() - 10, marginLeft: -($popup.outerWidth()-$origin.outerWidth())/2});
    $popup.fadeIn(200).delay(3500).fadeOut(400, function(){
      $(this).remove();
    });
  };
 $('#addToCart1').on('click', function(e) {
   e.preventDefault();
    var $form = $(this).closest('form[action^="/cart/add"]');
     if($form.closest('.GiftCardPopup').length == 0) {
       if($('#gc_name').val() == ''){
         alert('Please add recipient name');
         return false;
       }else if($('#gc_email').val() == ''){
         alert('Please add recipient email');
         return false;
       }
     }
    //console.log($form);
    //Disable add button
    // $form.find(':submit').attr('disabled', 'disabled').each(function(){
    //   var contentFunc = $(this).is('button') ? 'html' : 'val';
    //   $(this).data('previous-value', $(this)[contentFunc]())[contentFunc](theme.strings.productAddingToCartText);
    // });
  // $.post(shopifyAjaxAddURL, $form.serialize())
  // .done(function(itemData) {
  //   console.log('hi')
  // })
  // .fail(function(jqXHR, textStatus, errorThrown) {
  //   console.log('hieeee')
  // });
     
    //Add to cart
    $.post(shopifyAjaxAddURL, $form.serialize(), function(itemData) {
      
      $.createCookie('theme_added_to_cart','justnow',1);

      // Update persistent cart summaries
      if($form.closest('.product-add').length == 0) {
        // enable add button
        var $btn = $form.find(':submit').each(function(){
          var $btn = $(this);
          var contentFunc = $(this).is('button') ? 'html' : 'val';
          //Set to 'DONE', alter button style, wait a few secs, revert to normal
          $btn[contentFunc]('Added');
          setTimeout(function(){
            $btn.removeAttr('disabled')[contentFunc]('Add to cart');
          }, 4000);
        }).first();
        
        // update and reveal sidebar
        // updateCartSummaries(true);
      } else {
        // transition out form
        var itemData = itemData;
        // get full product data
        if(!theme.productData[itemData.product_id]) {
          theme.productData[itemData.product_id] = JSON.parse(document.getElementById('ProductJson-' + itemData.product_id).innerHTML);
        }
        var productPrice = '';
        for(var i=0; i<theme.productData[itemData.product_id].variants.length; i++) {
          var variant = theme.productData[itemData.product_id].variants[i];
          if(variant.id == itemData.variant_id) {
            if(variant.compare_at_price && variant.compare_at_price > variant.price) {
              productPrice += [
                '<span class="added-notice__price-compare theme-money">',
                theme.Helpers.formatMoney(variant.compare_at_price, theme.money_format),
                '</span> ',
                '<span class="added-notice__price-reduced theme-money">',
                theme.Helpers.formatMoney(itemData.price, theme.money_format),
                '</span>'
              ].join('');
            } else {
              productPrice += '<span class="theme-money">' + theme.Helpers.formatMoney(itemData.price, theme.money_format) + '</span>';
            }
          }
        }
        var productVariants = '';
        var suggestions= '';
      if(itemData.properties) {
          for (var key in itemData.properties){
            productVariants = '<div class="added-notice__product__variants"><span>'+ key+" : </span><span class='size'>" + itemData.properties[key] + '</span></span>';
              productVariants += '</div>';
          }
        }
        
        var suggestions = '<div class="ajax_cart_upsell_popup"></div>';
        var additional_details = '<ul>'+
                // '<li>Free Returns for 14 days</li>'+
                '<li>Extended Returns till January 31st</li>'+
                '<li>90 Day Exchanges</li>'+
                '<li>365 Day Jewellery Warranty</li>'+
              '</ul>'+
            '<div class="payment-options-images"><img src="https://cdn.shopify.com/s/files/1/0057/6657/8279/files/Zip_logo_rgb_light.png?v=1629767624">'+
            '<img src="https://cdn.shopify.com/s/files/1/0057/6657/8279/files/Humm_core_logo_RGB-01_300x60px_small_6a1b6009-a26e-4800-a67e-ce9e58fc6dd7.png?v=1571884828">'+
            '<img src="https://cdn.shopify.com/s/files/1/0057/6657/8279/files/afterpay-logo-png-black-transparent.png?v=1616483054">'+
            '<img src="https://cdn.shopify.com/s/files/1/0057/6657/8279/files/afterpay-logo-png-black-transparent.png?v=1616483054"></div>';
        if($form.hasClass('showpopAjax')) {
          if($('.upsell_slider_popup').length > 0) {
            suggestions+=$('.upsell_slider_popup').html();
          }          
        }

        $form.closest('.product-add').animate({ opacity: 1 }, 500, function(){

          var $template = $([
            '<div class="added-notice" style="opacity: 0">',
            '<div class="added-notice__product">',
            '<div class="added-notice__product__description">',
            '<div class="added-notice__description_top">',
            '<div class="added-notice__tick">', theme.strings.tick, '</div>',
            '<div class="added-notice__title">Congratulations! Added to cart</div>',
            '</div>',
            '<div class="tabel-list">',
            '<div class="added-notice__checkout"><a class="button" href="/cart">', theme.strings.layoutCartSummaryText2, '</a></div>',
            //'<div class="custom__checkout"><a class="btn checkout bold_clone" href="/checkout" data-event-queue-button="4">', , '</a></div>',
            '<div class="added-notice__continue"><a class="close-box more-link" href="#">', theme.strings.cartContinueText, '</a></div>',
            additional_details,
            '</div>',
            '</div>',
            '</div>',              
            suggestions,
            '</div>'
          ].join(''));
          $.colorbox({
            closeButton: false,
            preloading: false,
            open: true,
            speed: 200,
            transition: "elastic",
            html: ['<div class="action-icons">',
                  '<a href="#" class="close-box action-icon">X</a>',
                  '</div>', $template.wrap('<div>').parent().html()].join(''),
            onComplete: function(){
              upsellSlider_pdp();
              $('.added-notice').animate({ opacity: 1 }, 500);
              // theme.runMultiCurrency();
              $(this).colorbox.resize(); 
            }
          });
        });
        // update sidebar
        // updateCartSummaries(false);
      }
    }, 'json').fail(function(data) {
     
      //Enable add button
      var $firstBtn = $form.find(':submit').removeAttr('disabled').each(function(){
        var $btn = $(this);
        var contentFunc = $btn.is('button') ? 'html' : 'val';
        $btn.removeAttr('disabled')[contentFunc]('Add to cart');
      }).first();
      //Not added, show message
      if(typeof(data) != 'undefined' && typeof(data.status) != 'undefined') {
        var jsonRes = $.parseJSON(data.responseText);
        window.showQuickPopup(jsonRes.description, $firstBtn);
      } else {
        //Some unknown error? Disable ajax and submit the old-fashioned way.
        $form.addClass('noAJAX');
        $form.submit();
      }
    });
    return false;
  });


  $('.care-plan-block').each(function(){
    var selectedBlock = $(this).attr('id');
    
    $(this).click(function(){
      $('.care-plan-block').removeClass('active');
      $(this).addClass('active');
      $('html, body').animate({
          scrollTop: $("#plan-details").offset().top - 240
      }, 800);
      
        $('.care-plan-details').each(function(){
            
            var showSelected = $(this).attr('data-class');
            if(selectedBlock == showSelected){
                $('.care-plan-details').hide();
                $(this).show();
            }
        });
    });
  });

  if($('.size-selector').length > 0){
    $('.size-selector').slick({
        infinite: true,
        loop: true,
        slidesToShow: 7,
        arrows: true,
        variableWidth: true,
        prevArrow: '<div class="arrow-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><path d="M64 0a64 64 0 1 0 64 64A64 64 0 0 0 64 0zm0 122a58 58 0 1 1 58-58 58 58 0 0 1-58 58z"></path><path d="M58 36a3 3 0 0 0-4 4l23.8 24-24 24a3 3 0 1 0 4.3 4l26-26a3 3 0 0 0 0-4z"></path></svg></div>',
        nextArrow: '<div class="arrow-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><path d="M64 0a64 64 0 1 0 64 64A64 64 0 0 0 64 0zm0 122a58 58 0 1 1 58-58 58 58 0 0 1-58 58z"></path><path d="M58 36a3 3 0 0 0-4 4l23.8 24-24 24a3 3 0 1 0 4.3 4l26-26a3 3 0 0 0 0-4z"></path></svg></div>',         
    });
  }
  $('body').on('click', '.action-icons .close-box', function(){
    $.colorbox.close();
  });
  /* Show product thumb on mobile after the image*/
  if($(window).width() <= 740){
    if($('#thumbnails').length > 0){
      $('#thumbnails').insertAfter('#slider');
      $('.product__gallery--container').removeClass('product__gallery--container').addClass('product__gallery--container1');
      $('#thumbnails').removeClass('vertical-carousel').removeClass('mobile-hide').addClass('horizontal-carousel span-12 mobile-hide1');
      $('.thumb-slider-slides').css({'display':'flex','flex-direction':'row'});
    }
  }
  /* Show product thumb on mobile after the image*/

  $(".eternityPhone").on("change paste keyup", function() {
    var eternityPhone = $(this).val();
    eternityPhone = eternityPhone.replace(/\s+/g, "");
    $("#eternity_number_field.new #eternity_number_new").val(eternityPhone);
  });
  $(".eternityPhone").val("").trigger("change");
  var ecx="",ecm="",ecp="",ecv='{"phone": "'+ecp+'", "ec_number":"'+ecx+'", "is_already_ec_member": "'+ecm+'"}';
  $('[name="eternity_check"]').on("change",function(){
    var e=$('[name="eternity_check"]:checked').val();
    "no"==e?$("div#eternity_number_field").hide():"yes"==e&&$("div#eternity_number_field.existing").show(),
    ecp=$(".eternityPhone").val(),
    ecx=$(".eternityNum:visible").val(),
    ecm=$('[name="eternity_check"]:checked').val(),
    void 0===ecx&&(ecx=""),
    void 0===ecm&&(ecm=""),
    ecv='{"phone": "'+ecp+'", "ec_number":"'+ecx+'", "is_already_ec_member": "'+ecm+'"}',
    ecv='{"phone": "'+ecp+'", "ec_number":"'+ecx+'", "is_already_ec_member": "'+ecm+'"}',
    $("#eternity_field").val(ecv)
  });
  $(".eternityNum").on("change",function(){
    	ecp=$(".eternityPhone").val(),
    	ecx=$(".eternityNum:visible").val(),
    	ecm=$('[name="eternity_check"]:checked').val(),
    	void 0===ecx&&(ecx=""),
    	void 0===ecm&&(ecm=""),
    	ecv='{"phone": "'+ecp+'", "ec_number":"'+ecx+'", "is_already_ec_member": "'+ecm+'"}',
    	$("#eternity_field").val(ecv);
  });
  $(".eternityPhone").on("change",function(){
    	ecp=$(".eternityPhone").val(),
    	ecx=$(".eternityNum:visible").val(),
    	ecm=$('[name="eternity_check"]:checked').val(),
    	void 0===ecx&&(ecx=""),
    	void 0===ecm&&(ecm=""),
    	ecv='{"phone": "'+ecp+'", "ec_number":"'+ecx+'", "is_already_ec_member": "'+ecm+'"}',
    	$("#eternity_field").val(ecv);
  });
  $("#eternity_field").val("").trigger("change"),
  $('[name="eternity_check"]').first().prop("checked",!0).trigger("change");

  $(window).scroll(function(){
    var sticky = $('.R-LauncherButton'),
        scroll = $(window).scrollTop();
  
    if (scroll >= 100) sticky.addClass('hidereviewbar');
    else sticky.removeClass('hidereviewbar');
  });

  $(".ajax-cart__item-quantity .ajax-cart__qty-input").on("blur", function() {
    $(this).parents('.ajax-cart__item-qty').find('.button-as-link').click();
  });

  $(".stickybar.product button").on("click", function() {
    $('.button-entry #addToCart').click();
  });
  $(".stickybar.cart button").on("click", function() {
    $('.ajax-cart__buttons #checkout').click();
  });

  if(jQuery('.stickybar').length > 0 && jQuery(window).width() <= 1000){

    var $buttonavailable = 0;
    if(jQuery('.button-entry #addToCart').length > 0){
      var $atcbtn = jQuery('.button-entry #addToCart');
      $buttonavailable = 1;
    }else if(jQuery('.ajax-cart__buttons .ajax-cart__button-submit').length > 0){
      var $atcbtn = jQuery('.ajax-cart__buttons .ajax-cart__button-submit');
      $buttonavailable = 1;
    }
    if($buttonavailable == 1){
      //var $atcbtn = jQuery('.button-entry #addToCart');
      atcbuttonpotion = ($atcbtn.offset().top);
      jQuery(window).scroll(function () {
        //console.log(jQuery(window).scrollTop(), atcbuttonpotion, jQuery(window).outerHeight());
        if((atcbuttonpotion-jQuery(window).scrollTop()) >= jQuery(window).outerHeight() || jQuery(window).scrollTop() >= atcbuttonpotion){
          jQuery('.stickybar').show();
        }else{
          jQuery('.stickybar').hide();
        }
      });
    }
  }
  
});
$(document).ready(function()  {
  $('.defaultdisabled').removeClass('defaultdisabled');
  $(".slideout__trigger-search").on("click", function() {
    var w=$('#newnavigationnav').width();
    $('.search-form').css('width',w+'px');
      $('.search-bar').show();
  });
  $("#close_search").on("click", function() {
    $('.search-bar').hide();
  });
  $(".shopping__cart-links .slideout__trigger-search").on("click", function() {
    $('.search-form .ss__autocomplete__input').focus();
  });
  $(".subcollections a.department").on("click", function() {
    $(".subcollections a.department").removeClass('active');
    $(this).addClass('active');
  });
  $("#mailing-list #contact_form").submit(function(e) {
    e.preventDefault();
    window.location = "/pages/registration?email="+$('#mailinglist_email').val();
    return false;
  });
  if($('.subcollections_wrap').length > 0){
    var announcementinit = {
      autoplay: true,
      infinite: true,
      cssEase: "linear",
      slidesToShow: 8,
      slidesToScroll: 1,
      prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="fa fa-chevron-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="fa fa-chevron-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: true,
            slidesToShow: 6
          }
        },
        {
          breakpoint: 640,
          settings: {
            arrows: true,
            slidesToShow: 3
          }
        }
      ]
    };
    $(function () {
      var win = $(window);
      var announcementslider = $(".subcollections_wrap");
    
      win.on("load resize", function () {
        if (win.width() < 1100) {
          announcementslider.not(".slick-initialized").slick(announcementinit);
        } else if (announcementslider.hasClass("slick-initialized")) {
          announcementslider.slick("unslick");
        }
      });
    });
  }
});

